import { connect } from "react-redux";
import { accountName, isAdminUser, organizationName } from "../../selectors/selectors";
import { IState } from "../reducer";
import { AnalyticsComponent } from "./Analytics.component";
import { IAnalyticsStateProps } from "./types";

const mapStateToProps = (state: IState): IAnalyticsStateProps => ({
  authenticationState: state.App._.authenticationState,
  isAdmin: isAdminUser(state),
  location: state.router.location,
  organizationName: organizationName(state),
  userName: accountName(state),
});

export const Analytics = connect(mapStateToProps)(AnalyticsComponent);
